import React, { Dispatch, useRef, useState } from 'react';


import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Menu, MenuItem } from '@mui/material';
import { NotificationManager } from 'react-notifications';


import { ChevronToggle } from '@/components/common-components/ChevronToggle';

import ShortString from '../../../../common-components/ShortString/ShortString';
import TickIcon from '../../../../Icons/icons/TickIcon';
import { TransparentButton } from '../../../../styledComponents';
import AddIcon from '@/components/Icons/icons/AddIcon';
import CustomTooltip from '@/components/common-components/CustomTooltip/CustomTooltip';
import ModalComponent from '@/components/common-components/ModalComponent/ModalComponent';
import IconContainer from '@/components/common-components/FtuxComponent/IconContainer';
import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import { deleteUsageRightsTemplate } from '@/services/inboundEmailTemplate.service';
import { useCampaignDetail } from './CampaignDetailProvider';
import EditIcon from '@/components/Icons/icons/Edit';
import TrashIcon from '@/components/Icons/icons/TrashIcon';
import { system_templates } from '@/utils/ts/stringUtils';
import { AccordionListItem } from './SelectTemplate/AccordionListItem';

interface TemplateInterface {
  _id: string;
  name: string;
  body: string;
}

const SelectTemplate = ({ handleTemplateSelect, templates }: { handleTemplateSelect: (body: any) => void, templates: TemplateInterface[] }) => {
  const selectDivRef = useRef();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [expanded, setExpanded] = useState('myemail');

  // @ts-ignore
  const { selectedTemplate, setSelectedTemplate, setCreateNewModal, setDeleteTemplateModal, setIsCreateNewModal, setIsSystemTemplate } = useCampaignDetail();

  const onClickCreateTemplate = () => {
    setCreateNewModal(true);
    setIsDropdownOpen(false);
  };

  const handleChange = (panelName: string) => {
    setExpanded(panelName);
  };


  const _templates = system_templates.map(_template => {
    const matchingTemplate = templates.find((template: any) => template.name === _template.name);
    return matchingTemplate ? { ..._template, ...matchingTemplate } : _template;
  });

  const user_templates = [
    ...(templates?.filter((template: any) => template?.tag === 'user') || [])
  ]


  return (
    <>
      {/* @ts-ignore */}
      <div onClick={() => setIsDropdownOpen(true)} className="select-template-div flex request-usage-rights-select-template-container" ref={selectDivRef}>
        Select Template
        <ChevronToggle toggle={isDropdownOpen} color={'var(--icon-subdued)'} className="select-caret" />
      </div>
      <Menu
        id="basic-menu"
        anchorEl={selectDivRef?.current}
        open={isDropdownOpen}
        onClose={() => setIsDropdownOpen(false)}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        PaperProps={{
          sx: {
            // @ts-ignore
            width: selectDivRef?.target?.clientWidth,
            minHeight: 'fit-content',
            maxHeight: '300px',
            overflowY: 'scroll',
          },
        }}>
        <Accordion
          disableGutters
          expanded={expanded === 'myemail'}
          onChange={(e) => {
            e.stopPropagation();
            if (expanded === 'myemail' && user_templates?.length > 0) {
              handleChange('systemEmail');
            } else {
              handleChange('myemail');
            }
          }}
          defaultExpanded
          sx={{
            '&.MuiAccordion-root': {
              '::before': {
                content: 'none',
              },
            },
          }}>
          <AccordionSummary
            sx={{
              padding: '16px',
              '& .Mui-expanded': { minHeight: 'auto' },
              '& .MuiAccordionSummary-content': {
                margin: 0,
              },
              '&.MuiAccordionSummary-root': {
                minHeight: 'auto',
                borderBottom: expanded === 'myemail' ? '1px solid var(--border-default)' : '',
              },
            }}
            expandIcon={<ExpandMoreIcon sx={{ fontSize: '24px', color: '#424242' }} />}>
            <div className="inbox-all-filter-accordion-title" style={{ color: 'var(--text-subdued)' }}>
              System Templates
            </div>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: '0px',
              maxHeight: '267px',
              width: '284px',
              overflowY: 'auto',
              '&.MuiAccordionDetails-root': { marginTop: '0px !important' },
            }}>
            <div className="inbox-filter-by-campaign-container" >
              {_templates?.map((template: any) => {
                const { _id, name, body } = template;
                const isActive = Boolean(
                  template?._id === selectedTemplate?._id
                );
                return (
                  <AccordionListItem
                    key={_id}
                    text={name}
                    onClick={() => {
                      handleTemplateSelect({ body: body });
                      setIsDropdownOpen(false);
                      setSelectedTemplate(template);
                    }}
                    setCreateNewModal={setCreateNewModal}
                    setIsCreateNewModal={setIsCreateNewModal}
                    setIsDropdownOpen={setIsDropdownOpen}
                    isSystemTemplate={true}
                    setIsSystemTemplate={setIsSystemTemplate}
                    isActive={isActive}
                    setDeleteTemplateModal={setDeleteTemplateModal}
                  />
                );
              })}
            </div>
          </AccordionDetails>
        </Accordion>

        {
          user_templates?.length < 1 ? (
            <TransparentButton
              style={{ color: 'var(--text-highlight)', borderTop: '1px solid var(--border-default)', justifyContent: "start", width: '100%', padding: '16px', fontSize: '14px' }}
              onClick={(e) => {
                e.stopPropagation();
                setCreateNewModal(true);
                setIsDropdownOpen(false);
                setIsSystemTemplate(false);
                setSelectedTemplate(null)
                setIsCreateNewModal(true);
              }}
            >
              {/* @ts-ignore */}
              <AddIcon color={'var(--purple-p-400)'} size={16} />
              Create Custom Template
            </TransparentButton>
          )
            : (
              <Accordion
                disableGutters
                expanded={expanded === 'systemEmail'}
                onChange={(e) => {
                  e.stopPropagation();
                  if (expanded === 'systemEmail') {
                    handleChange('myemail');
                  } else {
                    handleChange('systemEmail');
                  }
                }}
                defaultExpanded
                sx={{
                  '&.MuiAccordion-root': {
                    '::before': {
                      content: 'none',
                    },
                  },
                }}>
                <AccordionSummary
                  sx={{
                    padding: '16px',
                    '& .Mui-expanded': { minHeight: 'auto' },
                    '& .MuiAccordionSummary-content': {
                      margin: 0,
                    },
                    '&.MuiAccordionSummary-root': {
                      minHeight: 'auto',
                      borderTop: '1px solid var(--border-default)',
                      borderBottom: '1px solid var(--border-default)',
                    },
                  }}
                  expandIcon={<ExpandMoreIcon sx={{ fontSize: '24px', color: '#424242' }} />}>
                  <div className="inbox-all-filter-accordion-title" style={{ color: 'var(--text-subdued)' }}>
                    My Templates
                  </div>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    padding: '0px',
                    maxHeight: '267px',
                    overflowY: 'auto',
                    '&.MuiAccordionDetails-root': { marginTop: '0px !important' },
                  }}>
                  <div className="inbox-filter-by-campaign-container">
                    {user_templates?.map((template: any) => {
                      const { _id, name, body } = template || {};
                      const isActive = template?._id === selectedTemplate?._id
                      return (
                        <AccordionListItem
                          key={_id}
                          text={name}
                          onClick={() => {
                            handleTemplateSelect({ body: body });
                            setSelectedTemplate(template);
                            setIsDropdownOpen(false);
                          }}
                          setCreateNewModal={setCreateNewModal}
                          setIsCreateNewModal={setIsCreateNewModal}
                          setIsDropdownOpen={setIsDropdownOpen}
                          isSystemTemplate={false}
                          setIsSystemTemplate={setIsSystemTemplate}
                          isActive={isActive}
                          setDeleteTemplateModal={setDeleteTemplateModal}
                        />
                      );
                    })}
                    <div className="m-2">
                      <CustomTooltip title="You can only create 5 templates" show={user_templates.length >= 5}>
                        <TransparentButton
                          style={{ color: user_templates.length >= 5 ? 'var(--purple-p-200)' : "var(--purple-p-400)", padding: '0px', fontSize: '14px' }}
                          disabled={user_templates.length >= 5}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCreateNewModal(true);
                            setIsDropdownOpen(false);
                            setIsSystemTemplate(false);
                            setSelectedTemplate(null)
                            setIsCreateNewModal(true);
                          }}
                        >
                          {/* @ts-ignore */}
                          <AddIcon color={user_templates.length >= 5 ? 'var(--purple-p-200)' : 'var(--purple-p-400)'} size={16} />
                          Create Custom Template
                        </TransparentButton>
                      </CustomTooltip>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            )
        }
      </Menu>
    </>
  );
};

export default SelectTemplate;
